import React from "react";

function Pindrop(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 102 59"
    >
      <circle cx="29.808" cy="29.5" r="29" fill="#EEE"></circle>
      <circle cx="29.807" cy="29.501" r="25.282" fill="#F1EAFF"></circle>
      <path
        fill="#262626"
        d="M29.808 19.09a8.19 8.19 0 00-8.18 8.18c0 6.998 7.437 12.284 7.754 12.506a.743.743 0 00.853 0c.317-.222 7.753-5.508 7.753-12.507a8.188 8.188 0 00-8.18-8.18zm0 5.205a2.975 2.975 0 110 5.95 2.975 2.975 0 010-5.95z"
      ></path>
      <circle cx="72.192" cy="29.5" r="29" fill="#EEE"></circle>
      <circle cx="72.192" cy="29.501" r="25.282" fill="#FEECE6"></circle>
      <path
        fill="#262626"
        d="M72.195 19.09a8.189 8.189 0 00-8.18 8.18c0 6.998 7.436 12.284 7.754 12.506a.743.743 0 00.853 0c.317-.222 7.753-5.508 7.753-12.507a8.189 8.189 0 00-8.18-8.18zm0 5.205a2.975 2.975 0 110 5.95 2.975 2.975 0 010-5.95z"
      ></path>
    </svg>
  );
}

export default Pindrop;
